import { trigger, state, style } from '@angular/animations';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { Site } from '@classes/site';
import { WaitingTime } from '@classes/waiting-time';
import { DatatableBaseComponent } from '@components/datatable-base.component';
import { UiService } from '@services/ui.service';
import { WaitingTimesService } from '@services/waiting-times.service';

@Component({
  selector: 'app-waiting-times',
  templateUrl: './waiting-times.component.html',
  styleUrls: ['./waiting-times.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' }))
    ])
  ]
})
export class WaitingTimesComponent extends DatatableBaseComponent implements OnInit {
  waitingTimes: WaitingTime[];
  sitesAlreadyTaken: Site[];

  isLoading = false;

  dataSource: MatTableDataSource<WaitingTime>;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  displayedColumns = ['site', 'minutes', 'price', 'nonHourlyPrice', 'actions'];

  constructor(
    protected uiSrv: UiService,
    private route: ActivatedRoute,
    private waitingTimesSrv: WaitingTimesService
  ) {
    super(uiSrv);
  }

  ngOnInit(): void {
    this.getRouteData();
    this.initSub();
  }

  private getRouteData(): void {
    this.route.data
      .subscribe((data: { waitingTimes: any[] }) => {
        this.waitingTimes = data.waitingTimes;
        this.checkSitesAlreadyTaken();

        this.initTable();
      });
  }

  initSub() {
    this.addSubscription(
      this.waitingTimesSrv.waitingTimesListChanged
        .subscribe(waitingTimes => {
          this.waitingTimes = waitingTimes;
          this.dataSource.data = waitingTimes || [];
          this.dataSource.sort = this.sort;
          this.checkSitesAlreadyTaken();

          this.onEditFinished();
        })
    );
  }

  private initTable(): void {
    this.dataSource = new MatTableDataSource(this.waitingTimes);
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'site': return item.site.name;
        default: return item[property];
      }
    };
    this.dataSource.filterPredicate = (data, filter: string) => {
      const accumulator = (currentTerm, key) => {
        switch (key) {
          case 'site': return currentTerm + data.site.name;
          default: return currentTerm + data[key];
        }
      };
      const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
      // Transform the filter by converting it to lowercase and removing whitespace.
      const transformedFilter = filter.trim().toLowerCase();
      return dataStr.indexOf(transformedFilter) !== -1;
    };

    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;

  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  checkSitesAlreadyTaken() {
    this.sitesAlreadyTaken = [];
    this.waitingTimes.map(waitingTime => {
      this.sitesAlreadyTaken.push(waitingTime.site);
    })
  }
}
